import(/* webpackMode: "eager" */ "/codebuild/output/src1063942336/src/suptamins/webapp/suptamins-ai/src/app/page.tsx");
